import { render, staticRenderFns } from "./DeactivateReasonOther.vue?vue&type=template&id=0939b746&"
import script from "./DeactivateReasonOther.vue?vue&type=script&lang=ts&"
export * from "./DeactivateReasonOther.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports